import React, { FunctionComponent } from 'react';

import CardBox from '../CardBox';
import { Card } from '../../requests/caipirinha-api/interfaces/order.interface';
import { toCard } from '../../utils/money.util';

interface Props {
  card: Card;
}

const PaymentCard: FunctionComponent<Props> = ({ card }) => {
  return (
    <CardBox>
      <h5>Cartão do Pagamento</h5>
      <strong>{toCard(card.bin)}</strong>
    </CardBox>
  );
};

export default PaymentCard;
